<template>
  <div class="float" :style="{ height: windowHeight + 'px' }">
    <div class="float_con">
      <div class="line_item">
        <div
          class="float_item on"
          @click="
            goNavHandle({
              path: '/product/cart',
            })
          "
          :style="{
            backgroundImage:
              'url(' + require('../../assets/images/icon4.png') + ')',
          }"
        >
          购物车
        </div>
      </div>
      <div class="line_item">
        <div
          class="float_item"
          @click="
            goNavHandle({
              path: '/mine/collection',
            })
          "
          :style="{
            backgroundImage:
              'url(' + require('../../assets/images/icon5.png') + ')',
          }"
        >
          收藏
        </div>
      </div>
      <div class="line_item">
        <div
          class="float_item"
          :style="{
            backgroundImage:
              'url(' + require('../../assets/images/icon6.png') + ')',
          }"
        >
          1
        </div>
      </div>
      <div class="line_item" @click="getSupplier" v-if="showNav">
        <div
          class="float_item"
          :style="{
            backgroundImage:
              'url(' + require('../../assets/images/icon7.png') + ')',
          }"
        >
          客服
        </div>
      </div>
      <div class="item_arr" v-scroll-to="'#index'">返回</div>
    </div>
  </div>
</template>
<script>
import { ref, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { posts } from '../../utils/posts'
export default {
  setup () {
    const router = useRouter()
    const store = useStore()
    const route = useRoute()
    const showNav = ref(false)
    const windowHeight = ref(0)
    const goNavHandle = (obj) => {
      router.push(obj)
    }
    watch(() => route.path, (path) => {
      console.log(path)
      if (path.startsWith('/product/detail')) {
        showNav.value = true
      } else {
        showNav.value = false
      }
    })

    // 客服
    const customerHandle = () => {
      const isCustom = store.state.isCustomCustomer
      if (!isCustom) {
        getSupplier()
      } else {
        store.state.isCustomCustomer = !store.state.isCustomCustomer
      }
    }
    // 客服
    const getSupplier = () => {
      posts('supplier/supplierInfo', { supplierId: store.state.supplierId }).then((res) => {
        const supplier = res.data
        store.state.supplierId = supplier.id
        store.state.supplierName = supplier.name
        store.state.supplierAvatar = supplier.logo
        store.state.isCustomCustomer = !store.state.isCustomCustomer
      })
    }

    onMounted(() => {
      windowHeight.value = document.documentElement.clientHeight
    })
    return {
      windowHeight,
      showNav,
      getSupplier,
      customerHandle,
      goNavHandle
    }
  }
}
</script>
<style lang="scss" scoped>
.float {
  position:fixed;
  right: 0px;
  top: 0px;
  width: 53px;
  background: white;
  overflow: hidden;
  z-index: 9999;
  .float_con {
    width: 53px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .item_arr {
      position: absolute;
      left: 16px;
      bottom: 60px;
      width: 24px;
      height: 12px;
      background: url(../../assets/images/icon8.png);
      text-indent: -9999px;
      background-size: contain;
      cursor: pointer;
    }
    .line_item {
      width: 53px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: solid 1px #e8e8e8;
      padding: 0 0 16px 0;
      margin: 0 0 16px 0;
      &:last-child {
        border: none;
      }
      .float_item {
        width: 26px;
        height: 26px;
        background-size: contain;
        background-repeat: no-repeat;
        text-indent: -9999px;
        cursor: pointer;
        position: relative;
        &.on:before {
          content: ".";
          color: rgb(252, 0, 0);
        }
      }
    }
  }
}
</style>
